import styled, { css } from 'styled-components';
import { DefaultIcon } from './Icon';
import { BlueLink } from './LinkStyles';
import { OutlineButton } from './ButtonStyles';

export const CardWrapperDiv = styled.div`
  ${props => props.theme.defaultDropShadow};
  /* width: 294px; */
  min-height: 756px;
  border-top: 2px solid ${props => props.theme.black};
  position: relative;
  padding: 10rem;
  background-color: ${props => props.theme.white};

  @media screen and (max-width: 767px) {
    padding: 8rem 3rem;
  }
  @media screen and (min-width: 1024px) {
    padding: 10rem 6rem;
  }
  @media screen and (min-width: 1440px) {
    padding: 10rem;
  }
`;

export const XIcon = styled(DefaultIcon)`
  height: 1.6rem;
  width: 1.6rem;
  fill: ${props => props.theme.dustyGray};
  cursor: pointer;
  :hover {
    fill: ${props => props.theme.black};
  }
`;

export const EditLink = styled(BlueLink)`
  font-size: 1.3rem;
  ${props =>
    props.closeActive &&
    css`
      margin-right: 4rem;
    `}
  ${props => props.theme.fontStackHeader};
`;

export const SaveOutlineButton = styled(OutlineButton)`
  ${props =>
    props.closeActive &&
    css`
      margin-right: 4rem;
    `}
  width: auto;
`;

export const ActionWrapperDiv = styled.div`
  align-items: center;
  display: flex;
`;
export const ActionContainerDiv = styled.div`
  position: absolute;
  right: 5rem;
  top: 3rem;

  @media screen and (max-width: 768px) {
    right: 3.6rem;
  }
  @media screen and (max-width: 375px) {
    top: 3.5rem;
    right: 3rem;
  }
`;

export const SaveWrapperDiv = styled.div`
  display: flex;
  align-items: center;
  /* flex-direction: column; */
`;

export const ErrorText = styled.p`
  color: ${props => props.theme.red};
  margin-right: 1.5rem;
`;
